<onyx-data-widget
  [headingIcon]="{
    name: icon(),
    size: 20,
    color: $any(color()),
  }"
  [color]="$any(color())"
  [clickable]="isClickable()"
  (click)="openPointModal()"
>
  <onyx-address heading [address]="address()" format="city-flag"></onyx-address>

  <div class="items">
    <span>
      {{ pointLabel() | translate }}

      <span class="name {{ color() }}">{{ name() }}</span>
    </span>

    <span>
      {{ serviceTimeLabel() | translate }}

      <span class="time {{ color() }}">
        @let serviceTime = currentPoint().serviceTime;
        @if (serviceTime == null) {
          {{ 'labels.lack' | translate }}
        } @else {
          {{ serviceTime | duration }}
        }
      </span>
    </span>
  </div>
</onyx-data-widget>
